"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AcFormField_1 = require("../../form/AcFormField");
exports.AcPdfDateStampInputs = function (_a) {
    var setCompanyName = _a.setCompanyName, setDateFormat = _a.setDateFormat, setUserName = _a.setUserName, companyName = _a.companyName, dateFormat = _a.dateFormat, userName = _a.userName;
    var errorMessages = {
        halfWidth: 'ご指定の文字は入力できません',
        tooLong: '8文字以内でご入力ください',
        noError: '',
    };
    var halfWidthRegex = /[\uff61-\uff9f]/g;
    var _b = react_1.useState(errorMessages.noError), companyNameError = _b[0], setCompanyNameError = _b[1];
    var _c = react_1.useState(errorMessages.noError), userNameError = _c[0], setUserNameError = _c[1];
    var companyNameOnChange = function (_, value) {
        if (value.length > 8) {
            setCompanyNameError(errorMessages.tooLong);
        }
        else {
            setCompanyNameError(errorMessages.noError);
        }
        if (value.search(halfWidthRegex) !== -1) {
            setCompanyNameError(errorMessages.halfWidth);
        }
        setCompanyName(value.replace(/\v/, '').replace(halfWidthRegex, '').slice(0, 8));
    };
    var dateFormatOnChange = function (_, formatString) {
        setDateFormat(formatString);
    };
    var userNameOnChange = function (_, value) {
        if (value.length > 8) {
            setUserNameError(errorMessages.tooLong);
        }
        else {
            setUserNameError(errorMessages.noError);
        }
        if (value.search(halfWidthRegex) !== -1) {
            setUserNameError(errorMessages.halfWidth);
        }
        setUserName(value.replace(/\v/, '').replace(halfWidthRegex, '').slice(0, 8));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AcFormField_1.AcFormField, { onChange: companyNameOnChange, value: companyName, errorId: companyNameError, invalid: !!companyNameError, onBlur: function () { return setCompanyNameError(errorMessages.noError); }, label: "\u4E0A\u6BB5\uFF08\u5168\u89D28\u6587\u5B57\u4EE5\u5185\uFF09" }),
        react_1.default.createElement(AcFormField_1.AcFormField, { value: dateFormat, onChange: dateFormatOnChange, label: "\u4E2D\u6BB5", readOnly: true }),
        react_1.default.createElement(AcFormField_1.AcFormField, { onChange: userNameOnChange, value: userName, errorId: userNameError, invalid: !!userNameError, onBlur: function () { return setUserNameError(errorMessages.noError); }, label: "\u4E0B\u6BB5\uFF08\u5168\u89D28\u6587\u5B57\u4EE5\u5185\uFF09" })));
};
exports.AcPdfDateStampInputs.displayName = 'AcPdfDateStampInputs';
//# sourceMappingURL=AcPdfDateStampInputs.js.map